import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import PaymentsForm from "../triggers/triggers/forms/payments";

const actions = { closeModal };

const providerTrigerDepositModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Capture Provider Payment" onClose={closeModal}>
      <PaymentsForm />
    </Modal>
  );
};

export default connect(null, actions)(providerTrigerDepositModal);
